import { useNavigate, useSearchParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import CheckForgotPassword from "../../../../assets/images/forgot-password-check.png";

import * as S from "./styles";
import { SignInButton } from "../../components/SignInButton";
import { Logo } from "../../components/Logo";

export function ResetPasswordSuccessMessage() {
  const { t } = useTranslation();
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const email = searchParams.get("email");

  return (
    <S.SuccessMessagePage>
      <S.SuccessMessageContainer>
        <Logo />

        <img
          src={CheckForgotPassword}
          alt={t("checkConfirmation")}
          width="120px"
          height="120px"
        />
        <S.SuccessMessageText>
          {t("passwordSuccessfullyChanged")}
        </S.SuccessMessageText>

        <SignInButton
          onClick={() => navigate(`/signin?email=${email}`)}
          type="submit"
          title={t("signIn")}
        />
      </S.SuccessMessageContainer>
    </S.SuccessMessagePage>
  );
}
